// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Router from "next/router";
import * as AuthVm$PorterinFeature from "../../../view-model/AuthVm.mjs";
import * as AuthStore$PorterinFeature from "../../../domain/store/AuthStore.mjs";
import * as AuthUtils$PorterinFeature from "../../../domain/helpers/AuthUtils.mjs";
import * as NextImage$PorterinFeature from "../../../../../ui/components/NextImage.mjs";
import * as AuthContextV1$PorterinFeature from "../../../view-model/contexts/auth-context/AuthContextV1.mjs";
import * as CustomerNameCmp$PorterinFeature from "./CustomerNameCmp.mjs";
import * as CategoryAnalytics$PorterinFeature from "../../../../fare-estimate-v1/domain/helpers/CategoryAnalytics.mjs";
import * as CommonAnalyticsHelper$PorterinFeature from "../../../../../shared/core/helpers/CommonAnalyticsHelper.mjs";
import * as CustomerProfileTextCmp$PorterinFeature from "./CustomerProfileTextCmp.mjs";
import * as CustomerLogoutButtonCmp$PorterinFeature from "./CustomerLogoutButtonCmp.mjs";
import * as CustomerProfileModuleScss from "../../styles/CustomerProfile.module.scss";

var styles = CustomerProfileModuleScss;

function CustomerProfileCmp(Props) {
  var close_modal = Props.close_modal;
  var match = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var user = match.user;
  var router = Router.useRouter();
  React.useEffect((function () {
          var timeout_id = setTimeout((function (param) {
                  CommonAnalyticsHelper$PorterinFeature.publishPageLandEvent(CategoryAnalytics$PorterinFeature.getCategoryName(router), AuthStore$PorterinFeature.Profile.ga_page_landing);
                }), 0);
          return (function (param) {
                    clearTimeout(timeout_id);
                  });
        }), []);
  return React.createElement("div", {
              className: styles.wrapper
            }, React.createElement("div", {
                  className: styles["close-icon"],
                  onClick: (function (param) {
                      Curry._1(close_modal, undefined);
                    })
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: AuthVm$PorterinFeature.close_icon.src,
                      height: AuthVm$PorterinFeature.close_icon.height,
                      width: AuthVm$PorterinFeature.close_icon.width,
                      quality: 100.0,
                      alt: AuthVm$PorterinFeature.close_icon.alt
                    })), React.createElement("div", {
                  className: styles.profile
                }, React.createElement("div", {
                      className: styles.name
                    }, React.createElement(CustomerNameCmp$PorterinFeature.make, {
                          name: Belt_Option.getWithDefault(AuthUtils$PorterinFeature.name(user), AuthStore$PorterinFeature.Profile.default_name)
                        })), React.createElement("div", {
                      className: styles.details
                    }, React.createElement(CustomerProfileTextCmp$PorterinFeature.make, {
                          heading: AuthStore$PorterinFeature.Profile.mobile_label,
                          subheading: AuthUtils$PorterinFeature.mobile(user)
                        }), React.createElement(CustomerProfileTextCmp$PorterinFeature.make, {
                          heading: AuthStore$PorterinFeature.Profile.email_label,
                          subheading: Belt_Option.getWithDefault(AuthUtils$PorterinFeature.email(user), "")
                        })), React.createElement("div", {
                      className: styles.logout
                    }, React.createElement(CustomerLogoutButtonCmp$PorterinFeature.make, {
                          close_modal: close_modal
                        }))));
}

var make = CustomerProfileCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
